import { useState } from "react";
import "./ColorMatch.css";
import ModalBox from "../../components/ModalBox/ModalBox";
import PrimaryButton from "../../components/PrimaryButton/PrimaryButton";
import { initialModal, resultModal } from "./Modals";
import { trackGameStart } from "../../utils/trackEvents";

function getRandomColor() {
  const diff = Math.floor(Math.random() * 61) + 40;
  const minVal = 40,
    maxVal = 220 - diff;
  const min = Math.floor(Math.random() * (maxVal - minVal + 1)) + minVal;
  const max = min + diff;
  const mid = Math.floor(Math.random() * (max - min + 1)) + min;
  const [r, g, b] = [min, mid, max].sort(() => Math.random() - 0.5);
  return { r, g, b };
}

export default function ColorMatch() {
  const [target, setTarget] = useState(getRandomColor());
  const [guess, setGuess] = useState({ r: 0, g: 0, b: 0 });
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [showResult, setShowResult] = useState(false);

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    if (type === "number") {
      if (value === "") return setGuess((g) => ({ ...g, [name]: "" }));
      let v = parseInt(value, 10);
      if (v > 255) v = 255;
      setGuess((g) => ({ ...g, [name]: v }));
    } else {
      setGuess((g) => ({ ...g, [name]: Number(value) }));
    }
  };

  const getScore = () => {
    const dr = target.r - guess.r;
    const dg = target.g - guess.g;
    const db = target.b - guess.b;
    const distance = Math.sqrt(dr * dr + dg * dg + db * db);
    const raw = 100 - distance / 3.8;
    return parseFloat(Math.max(0, raw).toFixed(1));
  };

  const handleStart = () => {
    setIsModalOpen(false);
    trackGameStart("ColorMatch", 1);
  };

  const handleSubmit = () => {
    setShowResult(true);
    setIsModalOpen(true);
  };

  const handleNewRound = () => {
    setTarget(getRandomColor());
    setGuess({ r: 0, g: 0, b: 0 });
    setShowResult(false);
    setIsModalOpen(false);
  };

  const modalContent = showResult
    ? resultModal(guess, target, getScore())
    : initialModal();

  return (
    <div className="color-match-main">
      <div className="color-match-colors">
        <div className="color-match-colors-actual">
          <div className="color-match-colors-actual-title">GUESS COLOR</div>
          <div className="color-match-colors-actual-shade">
            <div
              className="color-box"
              style={{
                backgroundColor: `rgb(${guess.r},${guess.g},${guess.b})`,
              }}
            />
          </div>
        </div>
        <div className="color-match-colors-target">
          <div className="color-match-colors-target-title">TARGET COLOR</div>
          <div className="color-match-colors-target-shade">
            <div
              className="color-box"
              style={{
                backgroundColor: `rgb(${target.r},${target.g},${target.b})`,
              }}
            />
          </div>
        </div>
      </div>

      <div className="color-match-sliders">
        <div className="sliders">
          {["r", "g", "b"].map((ch) => (
            <div className="slider-row" key={ch}>
              <label>{ch.toUpperCase()}</label>
              <input
                type="range"
                name={ch}
                min="0"
                max="255"
                value={guess[ch]}
                onChange={handleChange}
              />
              <input
                type="number"
                name={ch}
                min="0"
                max="255"
                value={guess[ch] === "" ? "" : guess[ch]}
                onChange={handleChange}
                onBlur={(e) => {
                  if (e.target.value === "")
                    setGuess((g) => ({ ...g, [ch]: 0 }));
                }}
              />
            </div>
          ))}
        </div>
        <div className="color-match-submit">
          <PrimaryButton onClick={handleSubmit}>Submit</PrimaryButton>
        </div>
      </div>

      <ModalBox
        isOpen={isModalOpen}
        title={modalContent.title}
        description={modalContent.description}
        buttonText={modalContent.buttonText}
        buttonType={modalContent.buttonType}
        onClose={showResult ? handleNewRound : handleStart}
      />
    </div>
  );
}
